import type { Gallery } from '@/core/features/image-v2/gallery-type';

import dynamic from 'next/dynamic';

import { classnames } from '@/core/utils/bem-classname';
import GalleryAdditionalImageLayer from '@/features/gallery-v1/gallery-elements/gallery-additional-image-layer';
import GalleryImage from '@/features/gallery-v1/gallery-elements/gallery-image';
import { useGalleryOverlayHistory } from '@/features/gallery-v1/gallery-overlay/gallery-overlay-state';

const GalleryOverlay = dynamic(
    () => import(/* webpackChunkName: "GalleryOverlay" */ '@/features/gallery-v1/gallery-overlay/gallery-overlay'),
);

import type { GalleryV1Attributes } from '@/features/gallery-v1/gallery-v1-type';

import { isVideo } from '@/core/features/video/video-service';

import styles from './gallery-v1.module.scss';

export type GalleryV1Props = GalleryV1Attributes;

export default function GalleryV1({ gallery, overlayTitle }: GalleryV1Props) {
    const { closeOverlay, isOverlayOpen, openOverlay } = useGalleryOverlayHistory();
    const imageCount = 5;

    return (
        <div>
            <div
                className={`${styles.container} full-width`}
                onClick={openOverlay}
            >
                {gallery.slice(0, 5).map((item, index) => {
                    const height = index < 2 ? 118 : 131;

                    return (
                        <div
                            className={classnames(styles.image, styles[`image${index + 1}`])}
                            data-qa-id={'qa-gallery-image'}
                            key={`${getGalleryItemKey(item)}-${index}`}
                        >
                            <GalleryImage
                                height={height}
                                image={isVideo(item) ? item.poster : item}
                                isVideo={isVideo(item)}
                                layoutWidth={index < 2 ? 50 : 33}
                                preload={true}
                            />
                            <GalleryAdditionalImageLayer
                                gallery={gallery}
                                imageCount={imageCount}
                                index={index}
                            />
                        </div>
                    );
                })}
            </div>
            {isOverlayOpen && (
                <GalleryOverlay
                    gallery={gallery}
                    onClose={closeOverlay}
                    overlayTitle={overlayTitle}
                />
            )}
        </div>
    );
}

const getGalleryItemKey = (item: Gallery[0]) => {
    if (isVideo(item)) {
        return item.videoUrl;
    }
    return item.imageUrl;
};
